export const TID = {
  nav: {
    logo: "nav-logo",
    link: (id) => `nav-link-${id}`,
    aidaBtn: "nav-aida-btn",
    mobileToggle: "nav-mobile-toggle",
  },
  hero: {
    discoverBtn: "hero-discover-btn",
    aidaBtn: "hero-aida-btn",
    philosophyCard: (id) => `philosophy-card-${id}`,
  },
  build: {
    tab: (id) => `build-tab-${id}`,
  },
  partner: {
    card: (id) => `partner-card-${id}`,
    talkBtn: "partner-talk-btn",
  },
  connect: {
    name: "contact-name",
    email: "contact-email",
    reason: "contact-reason",
    company: "contact-company",
    message: "contact-message",
    submit: "contact-submit",
    aidaOpen: "connect-aida-open",
  },
  aida: {
    panel: "aida-panel",
    close: "aida-close",
    input: "aida-input",
    send: "aida-send",
    chip: (i) => `aida-chip-${i}`,
  },
  footer: {
    jump: (id) => `footer-jump-${id}`,
  },
};

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "why", label: "Why We Exist" },
  { id: "build", label: "What We Build" },
  { id: "who", label: "Who We Are" },
  { id: "partner", label: "How We Partner" },
  { id: "team", label: "Team" },
  { id: "connect", label: "Connect" },
];
